import React, { useEffect } from "react";
import { Typography, Button, Grid } from "@mui/material";
import colors from "../../../../colors";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  displayMainUtilityView,
  resetDigitalbSlice,
  changeConfirmationDialogState,
} from "../../../../../features/digitalb/digitalbSlice";
import { sendGeneralRequest } from "../../../../../features/generalRequest";
import {
  selectBasicAccountState,
  setShouldBasicAccountPaymentRun,
  setTransactionIdToCancel,
} from "../../../../../features/basicAccount/basicAccountSlice";
import { runBasicAccountPayment } from "../../../../general/BasicAccountMethods";
import { selectUserInfo } from "../../../../../features/userInfo/userInfoSlice";
import ConfirmationDialog from "../../../../general/ConfirmationDialog";
import { texts } from "../../../../general/texts";
import { useLocation } from "react-router-dom";
import { selectUtilityState } from "../../../../../features/utilities/utilitySlice";

const SingleExpandedInvoice = (props) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const state = props.invoice;
  const basicAccountSliceState = useSelector(selectBasicAccountState);
  const utilitySliceState = useSelector(selectUtilityState)
  const location = useLocation();
  const urlSegments = location.pathname.split("/");
  const isDigitalbOTT = urlSegments[urlSegments.length - 1] === "DIGITALBOTT";

  const handleBackButton = () => {
    dispatch(resetDigitalbSlice());
    dispatch(setShouldBasicAccountPaymentRun(false));
  };

  const handleConfirmation = () => {
    {
      isDigitalbOTT
        ? dispatch(
            sendGeneralRequest({
              request: {
                token: props.globalDataSliceState.token,
                transID: props.digitalbSliceState.transactionId,
                service: props.utilityName,
                passkey: utilitySliceState.pin, 
                passkeyType: 1, 
                comeFromWeb: true
              },
              baseUrlKey: "services",
              endpoint: "DGA/ConfirmTransactionOTT",
            })
          )
        : dispatch(
            sendGeneralRequest({
              request: {
                token: props.globalDataSliceState.token,
                transID: props.digitalbSliceState.transactionId,
                service: props.utilityName,
                passkey: utilitySliceState.pin, 
                passkeyType: 1, 
                comeFromWeb: true
              },
              baseUrlKey: "services",
              endpoint: "DGA/ConfirmTransaction",
            })
          );
    }
  };
  const handleConfirmTransaction = () => {
    if (props.digitalbSliceState.isTransactionSuccessfullyStarted) {
      if (userInfo.accountType === 3) {
        dispatch(
          sendGeneralRequest({
            request: {
              token: props.globalDataSliceState.token,
              applicationID: 1,
              paymentMethod: "2",
              value: state.Totali.replace(/[^.\d]/g, ""),
              transID: props.digitalbSliceState.transactionId,
            },
            baseUrlKey: "services",
            endpoint: "startCreditCardPayment",
          })
        );
        dispatch(
          setTransactionIdToCancel(props.digitalbSliceState.transactionId)
        );
      } else {
        dispatch(changeConfirmationDialogState());
      }
      // userInfo.accountType === 3
      // ? dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token,applicationID:1, paymentMethod: '2', value: state.Totali.replace(/[^.\d]/g,''), transID: props.digitalbSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
      // : dispatch(changeConfirmationDialogState())
    }
  };

  useEffect(() => {
    const handleLocationChange = () => {
        dispatch(setShouldBasicAccountPaymentRun(false));
    };

    handleLocationChange(); // Initial call to handle location on mount

    return () => {
        handleLocationChange(); // Call on unmount
    };
}, [location, dispatch]);

  return (
    <>
      <Grid container justifyContent={"center"} p={3}>
        {basicAccountSliceState.shouldBasicAccountPaymentRun ? (
          runBasicAccountPayment(
            dispatch,
            basicAccountSliceState.basicAccountPaymentUrl,
            isDigitalbOTT
        ? dispatch(
            sendGeneralRequest({
              request: {
                token: props.globalDataSliceState.token,
                transID: props.digitalbSliceState.transactionId,
                service: props.utilityName,
                passkey: utilitySliceState.pin, 
                passkeyType: 1, 
                comeFromWeb: true
              },
              baseUrlKey: "services",
              endpoint: "DGA/ConfirmTransactionOTT",
            })
          )
        : dispatch(
            sendGeneralRequest({
              request: {
                token: props.globalDataSliceState.token,
                transID: props.digitalbSliceState.transactionId,
                service: props.utilityName,
                passkey: utilitySliceState.pin, 
                passkeyType: 1, 
                comeFromWeb: true
              },
              baseUrlKey: "services",
              endpoint: "DGA/ConfirmTransaction",
            })
          ),
            {
              request: {
                token: props.globalDataSliceState.token,
                orderId: props.digitalbSliceState.transactionId,
              },
              baseUrlKey: "services",
              endpoint: "cancelCreditCardPayment",
            },
            handleBackButton
          )
        ) : (
          <>
            <Grid container pt={3} pb={2}>
              <Grid
                container
                item
                md={1.5}
                xs={3}
                justifyContent={"left"}
                alignContent={"center"}
              >
                <Button
                  onClick={() => {
                    dispatch(displayMainUtilityView());
                  }}
                  sx={{
                    height: "4rem",
                    borderRadius: "100%",
                    ":hover": { background: colors.white },
                  }}
                >
                  <ArrowBackIosNewIcon color="warning" />
                </Button>
              </Grid>
            </Grid>
            <Grid container md={12} pb={"10%"} item>
              {Object.entries(state).map(([key, value]) => {
                return (
                  <Grid container item md={12} pb={"5%"} pr={"5%"}>
                    <Grid container item justifyContent="flex-start" md={6}>
                      <Typography
                        style={{
                          color: colors.darkBlue,
                          fontFamily: "GerberaBold",
                          fontSize: "1.9vh",
                        }}
                      >
                        {key}
                      </Typography>
                    </Grid>
                    <Grid container item justifyContent="flex-end" md={6}>
                      <Typography
                        style={{
                          color: key === "Totali" ? colors.orange : colors.gray,
                          fontSize: "1.8vh",
                          fontFamily: "GerberaLight",
                        }}
                      >
                        {value}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <Grid container item justifyContent={"center"} pb={"2%"} md={12}>
              <Button
                onClick={handleConfirmTransaction}
                style={{
                  background: colors.gradientOrange,
                  width: "100%",
                  color: colors.white,
                  textTransform: "none",
                  fontFamily: "GerberaBold",
                }}
              >
                {texts["title-pay"]}
              </Button>
            </Grid>
          </>
        )}
      </Grid>
      {props.digitalbSliceState.isConfirmationDialogOpen && (
        <ConfirmationDialog
          handleClose={() => {
            dispatch(changeConfirmationDialogState());
          }}
          isConfirmationDialogOpen={
            props.digitalbSliceState.isConfirmationDialogOpen
          }
          data={texts["message-confirm-transaction-general"]}
          handleConfirmationClick={handleConfirmation}
        />
      )}
    </>
  );
};
export default SingleExpandedInvoice;
